import { Flex, Text } from '@mantine/core';
import { FC } from 'react';
import Form from 'components/form';
import { UpgradeWrapper } from 'components/upgrade';

interface PremiumSwitchProps {
  name: string;
  label: string;
  loading: boolean;
  onValueChange: (value: boolean, name: string) => void;
  description: string;
}

const PremiumSwitch: FC<PremiumSwitchProps> = ({
  name,
  onValueChange,
  label,
  loading,
  description,
}) => {
  return (
    <Flex gap="0.875rem" direction="column" mb="1.5rem">
      <UpgradeWrapper
        as={Form.Switch}
        upgradeTitle="Level up your insights!"
        upgradeDescription="Get call recordings and transcriptions to see what really drives results."
        componentProps={{
          styles: {
            label: { fontSize: '1rem', fontWeight: 600 },
          },
          label,
          name,
          showEdit: true,
          containerProps: { mt: '0.75rem' },
          onChange: (value: boolean) => onValueChange(value, name),
          disabled: loading,
          popoverProps: {
            position: 'bottom-start',
            offset: 25,
          },
        }}
      />
      <Text size="sm" c="dimmed">
        {description}
      </Text>
    </Flex>
  );
};

export default PremiumSwitch;
